import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Alert, Button } from 'react-bootstrap';
import axios from "axios";
import { hashPassword } from './Functions/LoginFunctions';
import { API_ENDPOINTS } from '../config';

function Login({ onLogin }) {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showAlert, setShowAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const normalizeToken = (t) => {
    if (!t) return '';
    return String(t).replace(/^Bearer\s+/i, '').trim();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsError(false);
    setShowAlert(false);

    try {
      const email = (formData.email || '').trim();
      const passwordPlain = String(formData.password || '');

      if (!email || !passwordPlain) {
        throw new Error('Email and password are required');
      }

      const hashedPassword = await hashPassword(passwordPlain);

      const response = await axios.post(API_ENDPOINTS.LOGIN, {
        email: email,
        password: hashedPassword
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const token = normalizeToken(response.data?.token ?? response.data?.Token);
      if (token) {
        localStorage.setItem('JWToken', token);

        onLogin(response.data);
        navigate('/mainmenu');
      } else {
        throw new Error('No token received from server');
      }

    } catch (error) {
      setIsError(true);
      setShowAlert(true);

      if (error.response) {
        setErrorMessage(error.response.data?.message || error.response.data || `Error: ${error.response.status}`);
      } else if (error.request) {
        setErrorMessage('Network error - no response from server');
      } else {
        setErrorMessage(error.message || 'Login failed');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container fluid className="bg-chess min-vh-100 d-flex align-items-center">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <Card className="shadow bg-dark">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <h2 className="text-white">Login</h2>
                </div>

                {showAlert && (
                  <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                    {errorMessage || (isError ? 'Invalid email or password' : 'Login failed')}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label className='text-white d-block text-start w-100'>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="email@example.com"
                    />
                  </Form.Group>
                  <Form.Group className="mb-4" controlId="formPassword">
                    <Form.Label className='text-white d-block text-start w-100'>Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Password"
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 mb-3 bg-light-green txt-dark-green"
                    size="lg"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Logging in...' : 'Login'}
                  </Button>
                </Form>

                <div className="text-center">
                  <p className="mb-0 text-white">
                    Don't have an account?<br />
                    <Link to="/register" className="txt-light-green">
                      Register here
                    </Link>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Login;